import { BASKET_REQUEST, BASKET_SUCCESS, BASKET_FAILURE } from '../actions/types';

const initialState = {
  loading: false,
  error: undefined,
};

export default function basketReducer(state = initialState, action = {}) {
  switch (action.type) {
    case BASKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case BASKET_SUCCESS:
      return {
        ...state,
        loading: false,
        subtotal: action.payload.data.subtotal.formatted_amount,
        url: action.payload.data.links.web,
        error: undefined,
      };
    case BASKET_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          status: action.status,
        },
      };
    default:
      return state;
  }
}
